import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import '../../../context/actions.js';
import '../../../context/reducer.js';
import { useProductData } from '../../../context/product-context-hooks.js';
import '../../../context/ProductContext.js';
import '../../../context/CmsContext.js';
import '../../../types/product.js';
import { isSolutionsVariant } from '../../../types/typeguards.js';
import { ProductDetailDescription } from './ProductDetailDescription.js';

const ProductDetailDescriptionContainer = ({ className , children ,  })=>{
    const { getLabel  } = useIntl();
    const { activeVariant  } = useProductData();
    const { description , shortDescription , variantUsps  } = activeVariant;
    let title;
    let header = shortDescription;
    if (isSolutionsVariant(activeVariant)) {
        title = shortDescription || getLabel('products.solutions.header.header');
        header = undefined;
    }
    return /*#__PURE__*/ React.createElement(ProductDetailDescription, {
        className: className,
        title: title,
        header: header,
        description: description,
        usps: variantUsps,
        children: children
    });
};

export { ProductDetailDescriptionContainer };
//# sourceMappingURL=ProductDetailDescriptionContainer.js.map
